import { Box, Typography } from "@mui/material";

export function ScheduleCalendarEvent({ event }) {
  const assignment = event.resource || {};
  const label = assignment.teamName || assignment.teamId || event.title || "Class";

  return (
    <Box sx={{ lineHeight: 1.15, overflow: "hidden" }}>
      <Typography
        variant="caption"
        component="div"
        sx={{ fontWeight: 700, lineHeight: 1.15 }}
        noWrap
      >
        {label}
      </Typography>
      <Typography variant="caption" component="div" sx={{ lineHeight: 1.15 }} noWrap>
        {assignment.online ? "Online" : "In person"}
      </Typography>
    </Box>
  );
}
